<template>
  <transition name="fade" appear>
    <div class="cookie fixed w-100 bg-cl-white-smoke cl-black brdr-top-1 brdr-cl-secondary hidden-xs" :class="{ 'bottom80' : isProductPage }" v-if="isOpen">
      <div class="container">
        <div class="row between-xs middle-xs px15">
          <div class="col-xs-10 start-xs">
            <span class="h6">
              {{ $t('Strona korzysta z plików cookie w celu realizacji usług zgodnie z') }}
            </span>
            <router-link :to="localizedRoute($t('/i/polityka-prywatnosci'))" class="h6 cl-acc-orange underline">
              {{ $t('Polityką dotyczącą cookies.') }}
            </router-link>
            <span class="h6">
              {{ $t(' Możesz określić warunki przechowywania lub dostępu do cookie w Twojej przeglądarce.') }}
            </span>
          </div>
          <div class="col-xs-2 end-xs">
            <div class="flex icon p10 pointer" @mouseover="hover = true" @mouseleave="hover = false" @click="accept" @keyup.enter="accept" aria-label="Close cookie button" data-testid="closeCookieButton" tabindex="0" role="button">
              <close-svg width="16px" height="100%" :color="hover ? '#ffffff' : '#191919'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import CurrentPage from 'theme/mixins/currentPage'
import i18n from '@vue-storefront/i18n'
import CloseSvg from 'theme/components/theme/blocks/Icons/CloseSvg.vue'

export default {
  props: {
    detailsLinkText: {
      type: String,
      default: i18n.t('See details')
    },
    detailsLink: {
      type: String,
      default: '/privacy'
    },
    message: {
      type: String,
      default: i18n.t('We use cookies to give you the best shopping experience.')
    }
  },
  components: {
    CloseSvg
  },
  mixins: [CurrentPage],
  data () {
    return {
      isOpen: false,
      hover: false
    }
  },
  methods: {
    accept () {
      this.setVisited()
      this.isOpen = false
    },
    setVisited () {
      this.$store.dispatch('claims/set', { claimCode: 'cookiesAccepted', value: true })
    }
  },
  mounted () {
    this.$store.dispatch('claims/check', { claimCode: 'cookiesAccepted' }).then((cookieClaim) => {
      if (!cookieClaim) {
        this.isOpen = true
        this.$store.dispatch('claims/set', { claimCode: 'cookiesAccepted', value: false })
      } else {
        this.isOpen = !cookieClaim.value
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-icon: color(black);
$bg-icon: color(suva-gray);
$z-index: map-get($z-index, overlay);

.cl-acc-orange {
  color: #ae6010;
}
.cookie {
  z-index: $z-index;
  bottom: 0;
}
.icon {
  width: fit-content;
}
.icon:hover {
  color: $color-icon;
  background-color: $bg-icon;
}
</style>
